import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
// import Lightbox from "../components/react-images";
import { BackgroundImage, Modal } from "../components";

import GalleryLightbox from "../components/GalleryLightbox";

export default class GalleryImages extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  state = {
    currentCategory: 1,
    lightboxIsOpen: false,
    currentImage: 0
  };
  handleClickCategory = categoryId => {
    const { currentCategory } = this.state;
    if (currentCategory !== categoryId) {
      this.setState({ currentCategory: categoryId });
    }
  };
  handleClickImageItem = index => {
    this.setState({ lightboxIsOpen: true, currentImage: index });
  };

  handleClickImageItemMobile = (categoryId, imageIndex) => {
    this.setState({
      lightboxIsOpen: true,
      currentImage: imageIndex,
      currentCategory: categoryId
    });
  };
  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  };
  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  };
  gotoImage = index => {
    this.setState({
      currentImage: index
    });
  };
  closeLightbox = () => {
    this.setState({
      lightboxIsOpen: false
    });
  };
  render() {
    const { currentCategory, lightboxIsOpen, currentImage } = this.state;
    const { t, categories, images } = this.props;
    let galleryImages = images;
    if (currentCategory !== 1) {
      galleryImages = _.filter(galleryImages, { categoryId: currentCategory });
    }

    // Image for lightbox
    return (
      <div className="gallery-images">
        <div className="d-none d-sm-block">
          <div className="container">
            <div className="filter-bar">
              {_.map(categories, category => {
                const { id, name } = category;
                const activeClass = id === currentCategory ? "active" : "";
                return (
                  <div
                    key={id}
                    className={`text ${activeClass}`}
                    onClick={() => this.handleClickCategory(id)}
                  >
                    {t(name)}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="image-block">
            <div className="container">
              <div className="image-list">
                {_.map(galleryImages, (value, key) => {
                  const { image } = value;
                  console.log('image', image);
                  return (
                    <div
                      key={key}
                      className="item"
                      onClick={() => this.handleClickImageItem(key)}
                    >
                      <div className="image">
                        <BackgroundImage image={image} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="d-sm-none">
          <div className="image-sections">
            {_.map(_.omitBy(categories, cat => cat.id === 1), category => {
              const { id, name } = category;
              const categoryImages = _.filter(images, { categoryId: id });
              return (
                <div key={id}>
                  <div className="category-header-text">{t(name)}</div>
                  <div className="image-list">
                    {_.map(categoryImages, (value, imageIndex) => {
                      const { image } = value;
                      return (
                        <div
                          key={imageIndex}
                          className="item"
                          onClick={() =>
                            this.handleClickImageItemMobile(id, imageIndex)
                          }
                        >
                          <div className="image">
                            <BackgroundImage image={image} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {lightboxIsOpen && (
          <Modal name="gallery-images-modal" onCancel={this.closeLightbox}>
            <GalleryLightbox
              currentImage={currentImage}
              images={_.map(galleryImages, value => {
                return {
                  src: _.get(value, "image"),
                  caption: t(_.get(value, "name"))
                };
              })}
              onClickPrev={this.gotoPrevious}
              onClickNext={this.gotoNext}
              onClickThumbnail={this.gotoImage}
            />
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/GalleryImages.js